export default {
	ALL: {
		color: "#13b9b3",
		label: "Все статусы",
	},

	NEW: {
		color: "#10B879",
		label: "Новый",
		isSystem: true
	},
	IN_WORK: {
		color: "#E4003E",
		label: "В работе"
	},
	REST: {
		color: "#21367F",
		label: "Отдых"
	},
	WAITING_FOR_SPARE_PARTS: {
		color: "#EEC306",
		label: "Ожидание запчастей",
	},
	APPROVE: {
		color: "#A72681",
		label: "На согласование"
	},
	COMPLETED: {
		color: "#039752",
		label: "Выполнен"
	},
	EXECUTED: {
		color: "#44474C",
		label: "Завершен",
		isSystem: true
	},
	CANCELED: {
		color: "#F5386A",
		label: "Отменен",
		isSystem: true
	},

	DRAFT: {
		color: "#8E8E8E",
		label: "Черновик",
		isSystem: true
	},
	PROCESS: {
		color: "#2D4EC2",
		label: "В процессе",
		isSystem: true
	}
}
